const keys = require("../config/keys");

export const API_BASE_URL = keys.apiBaseUrl;

export const ACCESS_TOKEN = "accessToken";

export const OAUTH2_REDIRECT_URI = keys.redirectUri + "/oauth2/redirect";

export const GOOGLE_AUTH_URL = API_BASE_URL +  "/oauth2/authorize/google?redirect_uri=" + encodeURIComponent(OAUTH2_REDIRECT_URI);

export const base = keys.redirectUri;

export const VAPID_KEY = keys.vapid;